import { Box } from "@chakra-ui/react";
import { Row, Col } from "antd";
import Field from "ui/components/Input/Field";
import SelectIntervaloPeriodo from "ui/components/Input/SelectIntervaloPeriodo";
import InputMoney from "ui/components/Input/InputMoney";
import { RegraReservaComponentProps } from "../";

export default function TempoEntreReserva({
  control,
  watch,
  getNameLabel,
}: RegraReservaComponentProps) {
  const tipoIntervaloEntreReserva = watch("tipoIntervaloEntreReserva");

  return (
    <Box mb="48px">
      <Row gutter={32}>
        <Col sm={6}>
          <Field
            control={control}
            label="Formato de tempo"
            name="tipoIntervaloEntreReserva"
            render={({ field, isInvalid }) => (
              <SelectIntervaloPeriodo
                value={field.value}
                defaultValue={null}
                onChange={(value) => {
                  field.onChange(value);
                }}
                isInvalid={isInvalid}
                getPopupContainer={() => document.body}
              />
            )}
          />
        </Col>

        {tipoIntervaloEntreReserva ? (
          <Col sm={6}>
            <Field
              control={control}
              label={getNameLabel(tipoIntervaloEntreReserva)}
              name="intervaloEntreReserva"
              shouldUnregister
              render={({ field, isInvalid }) => (
                <InputMoney
                  isInvalid={isInvalid}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="0"
                  step={1}
                  decimalScale={0}
                  decimalsLimit={0}
                />
              )}
            />
          </Col>
        ) : null}
      </Row>
    </Box>
  );
}
